import type { LucideIcon } from 'lucide-react';

import { cn } from '@/utils/cn';

export type DropdownActionTone = 'default' | 'danger';

export type DropdownActionItem = {
  id: string;
  label: string;
  onSelect: () => void;
  disabled?: boolean;
  icon?: LucideIcon;
  tone?: DropdownActionTone;
};

type ActionDropdownMenuProps = {
  open: boolean;
  x: number;
  y: number;
  actions: DropdownActionItem[];
  onClose: () => void;
  className?: string;
  itemClassName?: string;
  dangerItemClassName?: string;
  iconClassName?: string;
};

export function ActionDropdownMenu({
  open,
  x,
  y,
  actions,
  onClose,
  className,
  itemClassName,
  dangerItemClassName,
  iconClassName,
}: ActionDropdownMenuProps) {
  if (!open) {
    return null;
  }

  return (
    <div
      className={cn('context-menu', className)}
      style={{ left: x, top: y }}
      onClick={(event) => event.stopPropagation()}
      onContextMenu={(event) => event.preventDefault()}
    >
      {actions.map((action) => {
        const Icon = action.icon;

        return (
          <button
            key={action.id}
            type="button"
            className={cn('context-menu__item', itemClassName, action.tone === 'danger' && dangerItemClassName)}
            onClick={() => {
              action.onSelect();
              onClose();
            }}
            disabled={action.disabled}
          >
            {Icon ? <Icon size={14} strokeWidth={2} aria-hidden="true" className={iconClassName} /> : null}
            <span>{action.label}</span>
          </button>
        );
      })}
    </div>
  );
}